import axios from "axios";
import { BACKEND_BASEURL } from "../../../db/baseUrl";
export const API_NOTIFICATION = `${BACKEND_BASEURL}api/notifications/`;

const getNotification = async () => {
  const response = await axios.get(API_NOTIFICATION + "getNotification");
  return response.data;
};

const deleteNotification = async (id) => {
  const response = await axios.delete(
    `${API_NOTIFICATION}deleteNotification/${id}`
  );
  return response.data;
};

const deleteAllNotifications = async (id) => {
  const response = await axios.delete(
    `${API_NOTIFICATION}deleteAllNotifications`
  );
  return response.data;
};

const NotificationServices = {
  getNotification,
  deleteNotification,
  deleteAllNotifications,
};
export default NotificationServices;
